export class Activity {
  description: string;
  initiatorId: string;
  initiatorUserName: string;
  timeStamp: string;
  type: string;
  title: string;
  fullName: string;
}
